// client/src/utils/badgeCount.generated.js
//
// GENERATED - do not edit by hand.
//
// Copied from packages/core/src/ui/badge.js by tools/sync-shared.py. Edit the core file and re-run that
// script; `node tools/marks-sheet-conformance.mjs` asserts this copy has not
// drifted from it.
//
// The phone imports the original. The web cannot (packages/core is outside
// client/src, and the CRA build will not resolve it), so it gets this. They must
// stay identical - a rule that exists twice and differs is the whole class of
// bug these files were written to end.
//
// What an unread badge shows once the count outgrows the disc it sits in.
// Both clients cap at the same number, or the same inbox reads differently
// on a phone and on a laptop.

/**
 * The number shown on an unread badge.
 *
 * A badge is a disc about sixteen pixels across sitting on top of an icon. Two
 * digits already crowd it; three overflow it, and the count then either clips or
 * stretches the disc into a lozenge that no longer reads as a badge at all. Past
 * a handful the exact number is not information anyone acts on — "more than you
 * are going to read right now" is the whole message.
 *
 * So it caps. `max` is 9 because a single digit is what the disc was sized for.
 *
 * Returns '' below 1, so a caller can render the result directly and get
 * nothing at all when there is nothing unread.
 *
 * @param {number} count
 * @param {number} [max=9]
 * @returns {string}
 */
export function formatBadgeCount(count, max = 9) {
  const n = Number(count);
  if (!Number.isFinite(n) || n < 1) return '';
  return n > max ? `${max}+` : String(Math.trunc(n));
}

/**
 * THE UNREAD BADGE'S OWN COLOURS — fixed, and deliberately not from the palette.
 *
 * The web asked the theme for these (`color="error"`, which resolves to
 * `error.main` over `error.contrastText`) and the theme measures contrast to
 * pick its ink. On three palettes the danger colour is a deep red and the
 * measurement returns white. On Dark Mode it is `#E5665F`, a light coral —
 * white on it is 3.28:1, under the 4.5:1 small text needs — so the measurement
 * correctly returned the DARK ink and the count came out near-black on coral.
 *
 * Right by contrast maths, wrong for this component. An unread badge is a red
 * disc with white digits in every product anyone has used; it is closer to an
 * icon than to a piece of themed text, and it has to read identically whichever
 * palette the school picked. The phone already treated it that way and the web
 * did not, which is how the same inbox came to look different on a laptop.
 *
 * #D32F2F carries white at 4.6:1, so the fixed pair is legible on its own terms
 * rather than by exemption.
 */
export const UNREAD_BADGE = { bg: '#D32F2F', fg: '#FFFFFF' };
